<header class="se-dashboard-header-compact">
  <div class="se-dashboard-header-compact__center">
    <h2>Dashboard Socioemocional</h2>
    <span class="subtitle">
      Aquí podrás ver el progreso de tus estudiantes en las habilidades socioemocionales.
    </span>
  </div>

  <div class="se-dashboard-header-compact__skills">
    <span
      class="skill-chip"
      *ngFor="let skill of skills; let i = index"
      [ngClass]="'color-' + (i % 8)" 
    >
      {{ skill.name }}
    </span>
  </div>
</header>
